import * as moment from 'moment';
import mapListSort from '../utils';

/**
{
  <username>: {
    fname,
    lname,
    ...
  },
  ...
}
*/
const defaultSort = 'last_updated';
const initialState = {
  activePage: 1,
  totalPages: false,
  agentBook: [],
  agentPage: [],
  agencyFilter: '',
  allSelectCheck: false,
  initialSelect: true,
  pageSize: 15,
  loading: false,
  records: [],
  searchTerm: '',
  selectedAgents: [],
  sortTerm: defaultSort,
  sortInverse: false,
  totalAgents: 50,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_AGENT': {
      const perms = action.payload.mmb_permissions || {};
      const mappedData = {
        // can_quote: action.payload.can_quote,
        // can_enroll: action.payload.can_enroll,
        // can_view_users: action.payload.can_view_users,
        // can_edit_users: action.payload.can_edit_users,
        // can_add_users: action.payload.can_add_users,
        // can_view_reports: action.payload.can_view_reports,
        // can_batch_upload: action.payload.can_batch_upload,
        // can_view_shopper_data: action.payload.can_view_shopper_data,
        // can_edit_translations: action.payload.can_edit_translations,
        // can_view_analytics: action.payload.can_view_analytics,
        // can_manage_agency: action.payload.can_manage_agency,
        // can_manage_campaigns: action.payload.can_manage_campaigns,
        // can_view_calls: action.payload.can_view_calls,
        // can_manage_agents_ap: action.payload.can_manage_agents_ap,
        // can_manage_campaigns_ap: action.payload.can_manage_campaigns_ap,
        // is_admin: action.payload.is_admin,
        // can_manage_formulary: action.payload.can_manage_formulary,
        // can_manage_logos: action.payload.can_manage_logos,
        // can_use_telephony: action.payload.can_use_telephony,
        ...action.payload,
        ...perms,
      };

      const indexToChange = state.agentPage
        .findIndex((a) => a.username === action.payload.username);
      const newAgentPage = state.agentPage;
      newAgentPage[indexToChange] = {
        ...newAgentPage[indexToChange],
        ...mappedData,
      };

      const pageToChange = state.activePage - 1;
      const newAgentBook = state.agentBook;
      newAgentBook[pageToChange] = newAgentPage;

      return {
        ...state,
        agentPage: state.agentPage.map((item, index) => {
          if (index !== indexToChange) {
            return item;
          }

          return {
            ...item,
            ...mappedData,
          };
        }),
        agentBook: state.agentBook.map((item, index) => {
          if (index !== pageToChange) {
            return item;
          }

          return newAgentBook[pageToChange];
        }),
      };
    }
    case 'SET_INITIAL_SELECT':
      return { ...state, initialSelect: action.payload };
    case 'SET_AGENCY_FILTER':
      return { ...state, agencyFilter: action.payload || '' };
    case 'SET_AGENT_SORT_TERM':
      /* eslint-disable no-case-declarations */
      const newSortTerm = action.payload ? action.payload : defaultSort;
      return { ...state, sortTerm: newSortTerm };
      /* eslint-enable no-case-declarations */
    case 'CLEAR_AGENT_SORT_TERM':
      return { ...state, sortTerm: defaultSort };
    case 'SET_AGENT_SORT_INVERSE':
      return { ...state, sortInverse: action.payload };
    case 'CLEAR_AGENT_SORT_INVERSE':
      return { ...state, sortInverse: false };
    case 'SET_SEARCH_TERM':
      return { ...state, searchTerm: action.payload };
    case 'CLEAR_SEARCH_TERM':
      return { ...state, searchTerm: '' };
    case 'SET_ACTIVE_STATUS': {
      const selectedAgents = state.selectedAgents
        .map((agent) => ({ ...agent, is_active: action.payload }));
      return { ...state, selectedAgents };
    }
    case 'SET_LOADING_AGENTS_STATUS':
      return { ...state, loading: action.payload };
    case 'SET_ALL_SELECT_CHECKBOX':
      return { ...state, allSelectCheck: action.payload };
    case 'CLEAR_SELECTED_AGENTS':
      return { ...state, selectedAgents: [] };
    case 'ADD_SELECTED_AGENT': {
      const selectedAgents = [...state.selectedAgents];
      selectedAgents.push(action.payload);
      return { ...state, selectedAgents };
    }
    case 'DESELECT_ALL_AGENTS': {
      const selectedAgents = Array.from(new Set([...state.selectedAgents].map((a) => a.username)));
      const agentsToRemove = Array.from(new Set(action.payload.map((a) => a.username)));
      const newAgentsList = [];
      selectedAgents.forEach((username) => {
        if (!agentsToRemove.includes(username)) {
          newAgentsList.push([...state.selectedAgents].find((a) => a.username === username));
        }
      });
      return { ...state, selectedAgents: newAgentsList };
    }
    case 'SELECT_ALL_AGENTS': {
      const selectedAgents = [...state.selectedAgents];
      const allSelectedAgents = selectedAgents.concat(action.payload);
      const filtered = Array.from(new Set(allSelectedAgents.map((a) => a.username)))
        .map((username) => (allSelectedAgents.find((a) => a.username === username)));
      return { ...state, selectedAgents: filtered };
    }
    case 'REMOVE_SELECTED_AGENT': {
      const selectedAgents = [...state.selectedAgents];
      const filtered = selectedAgents.filter((agent) => agent.username !== action.payload.username);
      return { ...state, selectedAgents: filtered };
    }
    case 'LOAD_AGENT_LIST': {
      const agentBook = [];
      const activePage = action.payload.Page;
      agentBook[activePage - 1] = action.payload.Users || [];

      return {
        ...state,
        agentBook,
        agentPage: agentBook[activePage - 1],
        totalAgents: action.payload.TotalUsers,
        pageSize: action.payload.MaxPageSize,
        totalPages: action.payload.TotalPages,
        activePage,
      };
    }
    case 'SET_ACTIVE_PAGE': {
      const agentBook = [...state.agentBook];
      return {
        ...state,
        activePage: action.payload,
        agentPage: agentBook[action.payload - 1],
      };
    }
    case 'CLEAR_AGENT_LIST': {
      return {
        ...state,
        agentBook: [],
        agentPage: [],
      };
    }
    case 'LOAD_AGENTS': {
      const users = action.users.map((user) => {
        // Check if this user already exists in records.
        const existing = state.records.find((agent) => agent.username === user.username);

        return {
          ...user,
          last_updated: moment(user.last_updated).format('MM-DD-YYYY H:mm:ss'),
          site: window.location.hostname.split('.').slice(-2).join('.'),
          // Preserve app state if user being refreshed.
          selected: existing ? existing.selected : false,
          visible: existing ? existing.visible : true,
        };
      });
      return { ...state, records: mapListSort(users, state.sortBy) };
    }
    case 'UPDATE_AGENT_SELECTION': {
      const i = state.records.findIndex((agent) => agent.username === action.username);
      const records = [...state.records];
      records[i] = { ...state.records[i], selected: action.selected };
      return { ...state, records };
    }
    case 'TOGGLE_ALL': {
      const records = state.records.map((user) => ({ ...user, selected: action.checked }));
      return { ...state, records };
    }
    case 'FILTER': {
      const term = action.term.toLowerCase();
      const records = state.records.map((user) => {
        const matches = Object.values(user).filter((data) => {
          if (data && data.includes && data.toLowerCase) {
            return data.toLowerCase().includes(term);
          }
          return false;
        });
        return { ...user, visible: matches.length > 0 };
      });
      return { ...state, records };
    }
    case 'SET_SELECTED_AGENT': {
      const perms = action.agent.mmb_permissions || {};
      return {
        ...state,
        selectedAgent: {
          ...action.agent,
          ...perms,
        },
      };
    }
    case 'CLEAR_SELECTED_AGENT':
      return { ...state, selectedAgent: false };
    case 'SET_AGENTS_FIELDS':
      return { ...state, ...action.payload };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
